import EventEmitter from "base/EventEmitter";
import $ from "jquery";
import GlobalEvents from "./GlobalEvents";

class FormValidator extends EventEmitter {
    constructor($form, options) {
        super();

        $form.data("Validator", this);

        options = $.extend(true, {
            inputs: {},
            inputOptions: {},
        }, "object" === typeof options ? options : {});

        this.options = options;
        this.$form = $form;

        this.inputs = [];
        this.inputsMap = {};
        this.updateInputs();

        $form.on("submit", () => {
            return this.submit();
        });

        setTimeout(() => {
            this.emit("init", this);
            GlobalEvents.emit(EVENT_GLOBAL_ATTACH, this);
        }, 0);
    }

    updateInputs() {
        //TODO handle removing inputs
        this.$form.find("input,select,textarea").filter(":not(.js-no-validate):not([type=button]):not([type=submit])").each((_, elem) => {
            this.handleInput($(elem));
        });
    }

    handleInput($input) {
        if ($input.data("Validator") instanceof FormInput) return;

        let name = $input.attr("name");
        let input = new FormInput($input, $.extend(true, {}, this.options.inputOptions, this.options.inputs[name]), this);
        this.inputs.push(input);
        this.inputsMap[name] = input;

        input.on("valid", (event) => {
            this.emit("input:valid", {
                input: input,
                event: event,
            });
            GlobalEvents.emit(EVENT_GLOBAL_INPUT_VALID, {
                input: input,
                event: event,
                form: this,
            });
        }).on("invalid", (event) => {
            this.emit("input:invalid", {
                input: input,
                event: event,
            });
            GlobalEvents.emit(EVENT_GLOBAL_INPUT_INVALID, {
                input: input,
                event: event,
                form: this,
            });
        });
    }

    validate() {
        this.emit("beforeValidate");
        let valid = true;

        this.inputs.forEach((input) => {
            if (!input.validate()) {
                valid = false;
            }
        });

        valid = this.emit("validate", this) && valid;

        return valid === true;
    }

    handleValidationException(e) {

        if (e.data && e.data.exception && e.data.exception === "HttpValidationException") {
            try {
                e.data.data.forEach((inputError) => {
                    let input = this.inputsMap[inputError.data.schema.name];

                    if ("undefined" === typeof input) {
                        console.warn("Invalid input returned in validation handler", inputError.data.schema.name, inputError);
                        return;
                    }

                    let event = {
                        valid: false,
                        message: inputError.message,
                    };
                    if (input.emit("invalid", event)) {
                        input.showMessage(event.message, "invalid");
                    }
                });
            } catch (e) {
                //Don't propagate error
                console.warn("Couldn't handle validation error", e);
            }
            return true;
        }

        return false;
    }

    submit() {
        if (this.validate()) {
            if (!this.emit("submit", this.$form)) {
                return true;
            }
        } else {
            this.emit("invalid", this.$form);
        }
        return false;
    }

    static attach($form, options) {
        return new FormValidator($form, options);
    }
}

class FormInput extends EventEmitter {
    constructor($input, options, form) {
        super();

        options = $.extend(true, {}, FormInput.defaultOptions, "object" === typeof options ? options : {});

        this.options = options;
        this.form = form;

        this.$input = $input;
        this.type = $input.is("[data-type]") ? $input.attr("data-type") : $input.attr("type");
        let $message;

        if ($.isFunction(options.getMessageElement)) {
            $message = options.getMessageElement.call(this);
        } else if ($input.is("[type='hidden']") && !$input.is("[data-has-message]")) {
            $message = $("<div>");
        } else {
            let $level = $input;
            do {
                $level = $level.parent();
                $message = $level.find(options.getMessageElement);


            } while ($level.length === 1 && $message.length === 0);
            if ($message.length > 1) {
                $message = $("<div>");
            }
            $message.hide();
        }

        this.$message = $message.hide();

        $input.on(options.events, () => {
            this.validate();
        }).data("Validator", this);
    }

    getMessage(type, context = {}) {
        return $.isFunction(this.options.getMessage) ? this.options.getMessage.call(this, type, context) : this.options.getMessage;
    }

    getOperator() {
        return $.isFunction(this.options.getOperator) ? this.options.getOperator.call(this) : this.options.operator;
    }

    valid() {
        return this._validate().valid;
    }

    validate() {
        let result = this._validate();

        if (result.valid) {
            if (this.emit("valid", result)) {
                if (this.options.hasSuccess && !result.hideMessage) {
                    this.showMessage(this.getMessage("success"), "valid");
                } else {
                    this.hideMessage();
                }
            }
        } else {
            if (this.emit("invalid", result)) {
                this.showMessage(result.message, "invalid");
            }
        }

        return result.valid;
    }

    _validate() {
        let valid = true;
        let message = "";
        let value;
        let hideMessage = false;

        if (this.$input.is(":disabled")) {
            return {
                valid,
                message,
                hideMessage,
            };
        }

        if ("function" === typeof this.options.customValidator) {
            let result = this.options.customValidator.call(this, this);

            if ("object" === typeof result) {
                valid = result.valid;
                message = result.message;
                hideMessage = result.hideMessage;
            } else {
                valid = !!result;

                if (!valid) message = this.getMessage("empty");
            }
        } else {
            if (this.$input.is(":checkbox") || this.$input.is(":radio")) {
                value = this.form.$form.find("input[name='" + this.$input.attr("name") + "']:checked").length > 0;
                if (!value && !this.$input.is("[data-optional]")) {
                    valid = false;
                    message = this.getMessage("unchecked");
                } else {
                    valid = true;
                }
            } else {
                value = this.$input.val();
                if ("string" === typeof value) {
                    value = value.trim();
                }

                if ("undefined" === typeof value || value === null || value.length === 0) {
                    if (!this.$input.is("[data-optional]")) {
                        valid = false;
                        message = this.getMessage("empty");
                    } else {
                        valid = true;
                        hideMessage = true;
                    }
                } else {
                    switch (this.type) {
                        case "email":
                            if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidEmail");
                            }
                            break;
                        case "number":
                            let number = this.$input.is("[data-number]") ? this.$input.attr("data-number") : "both";

                            if (!$.isNumeric(value)) {
                                valid = false;
                                message = this.getMessage("invalidNumber");
                            } else {
                                value = parseFloat(value);

                                if (number === "positive" && value < 0) {
                                    valid = false;
                                    message = this.getMessage("invalidPositiveNumber");
                                } else if (number === "negative" && value > 0) {
                                    valid = false;
                                    message = this.getMessage("invalidNegativeNumber");
                                } else {
                                    let min = this.$input.is("[min]") ? parseFloat(this.$input.attr("min")) : null;
                                    let max = this.$input.is("[max]") ? parseFloat(this.$input.attr("max")) : null;

                                    if (min !== null && value < min) {
                                        valid = false;
                                        message = this.getMessage("invalidNumberMin", {
                                            min,
                                            max,
                                        });
                                    } else if (max !== null && value > max) {
                                        valid = false;
                                        message = this.getMessage("invalidNumberMax", {
                                            min,
                                            max,
                                        });
                                    }
                                }
                            }
                            break;
                        case "tel":
                            if (!(/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ""))) {
                                valid = false;
                                message = this.getMessage("invalidPhone");
                            }
                            break;
                        case "url":
                            if (!/^(http[s]?:)?\/\/.+$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidUrl");
                            }
                            break;
                        case "slug":
                            if (!/^[^ ]+$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidSlugSpaces");
                            } else if (!/^[a-z0-9\-/]+$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidSlug");
                            }
                            break;
                        case "date":
                            if (!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidDate");
                            }
                            break;
                        case "time":
                            let regex = new RegExp("^[0-9]{2}:[0-9]{2}" + (this.$input.is("[data-short-time]") ? "" : ":[0-9]{2}") + "$");
                            if (!regex.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidTime");
                            }
                            break;
                        case "set-password":
                            if (value.length < 8) {
                                valid = false;
                                message = this.getMessage("passwordLength");
                            }
                            break;
                        default:
                            if (this.$input.is("[min-length]")) {
                                let minLength = parseInt(this.$input.attr("min-length"));

                                if (value.trim().length < minLength) {
                                    valid = false;
                                    message = this.getMessage("textTooShort", {minLength: minLength});
                                }
                            }
                            if (this.$input.is("[max-length]")) {
                                let maxLength = parseInt(this.$input.attr("max-length"));

                                if (value.trim().length > maxLength) {
                                    valid = false;
                                    message = this.getMessage("textTooLong", {maxLength: maxLength});
                                }
                            }
                            if (this.$input.is("[data-regex]")) {
                                let regex = new RegExp(this.$input.attr("data-regex"), this.$input.is("[data-regex-flags]") ? this.$input.attr("data-regex-flags") : "");

                                if (!regex.test(value)) {
                                    valid = false;
                                    message = this.getMessage("invalidRegex", {regex: regex});
                                }
                            }
                            break;
                    }
                }
            }
        }

        let event = {
            valid: valid,
            message: message,
            value: value,
        };

        valid = this.emit("validate", event) && event.valid;
        return {
            valid,
            message: event.message,
            hideMessage,
        };
    }

    showMessage(message, type) {
        if (!message) {
            this.hideMessage();
            return;
        }
        this.$message.text(message).removeClass(this.options.classes.valid + " " + this.options.classes.invalid).addClass(type === "valid" ? this.options.classes.valid : this.options.classes.invalid).show();
        if (type === "invalid") {
            this.$input.addClass(this.options.classes.inputInvalid).removeClass(this.options.classes.inputValid);
        } else {
            this.$input.removeClass(this.options.classes.inputInvalid).addClass(this.options.classes.inputValid);
        }
    }

    hideMessage() {
        this.$input.removeClass(this.options.classes.inputInvalid + " " + this.options.classes.inputValid);
        this.$message.hide();
    }

    getName() {
        if (this.$input.is("[data-name]")) {
            return this.$input.attr("data-name");
        } else if (this.$input.is("[name]")) {
            return this.$input.attr("name").replace(/(\B[A-Z]+?(?=[A-Z][^A-Z])|\B[A-Z]+?(?=[^A-Z]))/g, " $1").replace(/_/g, " ").toLowerCase();
        } else {
            return "value";
        }
    }
}


FormInput.defaultOptions = {
    messages: {
        empty: "You must enter {operator} {name}",
        unchecked: "This value is required",
        invalidEmail: "Please enter a valid email address",
        success: "",
        invalidNumber: "Please enter a number",
        invalidPositiveNumber: "Please enter a positive number",
        invalidNegativeNumber: "Please enter a negative number",
        invalidNumberMin: "Please enter at least {min}",
        invalidNumberMax: "Please enter at most {max}",
        invalidPhone: "Please enter a valid phone number",
        invalidUrl: "Please enter a valid URL",
        invalidSlug: "Please enter a valid Url. It must only contain letters, numbers, forward slashes and hyphens.",
        invalidSlugSpaces: "The Url must not contain spaces",
        invalidDate: "Please enter a valid date",
        invalidTime: "Please enter a valid time",
        invalidRegex: "Sorry, this value looks invalid",
        passwordLength: "Your password must be at least 8 characters long",
        textTooShort: "{operator} {name} must be at least {minLength} characters",
        textTooLong: "{operator} {name} must cannot be longer than {maxLength} characters",
    },
    operator: "the",
    hasSuccess: true,
    getMessage: function (type, context = {}) {
        context = $.extend(true, {
            operator: this.getOperator(),
            name: this.getName(),
        }, context);
        let message = this.options.messages[type];

        if ('undefined' === typeof message) {
            console.error("Undefined error message", {
                type,
                context,
            });
            return "Undefined error message: " + type;
        }

        $.each(context, (key, value) => {
            message = message.replace(new RegExp("{" + key + "}", "g"), value);
        });

        // Ensure the first character is upper case
        message = message.charAt(0).toUpperCase() + message.slice(1);

        return message;
    },
    getOperator: function () {
        return this.options.operator;
    },
    getMessageElement: ".js-inline-validation",
    events: "change blur keyup",
    classes: {
        valid: "form__inline-validation--success",
        invalid: "form__inline-validation--error",
        inputValid: "form__input--success",
        inputInvalid: "form__input--error",
    },
};

export default FormValidator;
export { FormValidator, FormInput };

export const EVENT_GLOBAL_ATTACH = "FormValidator.attach";
export const EVENT_GLOBAL_INPUT_INVALID = "FormValidator.input.invalid";
export const EVENT_GLOBAL_INPUT_VALID = "FormValidator.input.valid";
